import React from 'react';
import PropTypes from 'prop-types';
import styled from 'fe-styled-components';
import theme from 'fe-appdir-lib-theme';

const PROP_TYPES = {
  heading: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  link: PropTypes.func,
  graphic: PropTypes.func,
  borderColor: PropTypes.oneOf(['blue', 'purple', 'green']),
};

const DEFAULT_PROPS = {
  borderColor: 'blue',
  link: () => null,
  graphic: () => null,
};

const Container = styled.div`
  box-sizing: border-box;
  border-top: 9px solid;
  border-image: ${(props) =>
    props.borderColor === 'blue'
      ? `linear-gradient(to right, #2cd5c4, ${theme.colorBrandPrimary}) 1`
      : props.borderColor === 'purple'
      ? `linear-gradient(to right, #7f4d8f, ${theme.colorBrandPrimary}) 1`
      : props.borderColor === 'green'
      ? `linear-gradient(to right, #8BC832, ${theme.colorBrandPrimary}) 1`
      : null};
  padding: ${theme.verticalRhythmBase} ${theme.verticalRhythmBase} 30px;
  box-shadow: 0 5px 18px 3px rgba(0, 0, 0, 0.1);
  background: ${theme.colorWhite};
  font-family: ${theme.fontFamilyPrimary};
  font-size: ${theme.fontSizeBase};
  color: ${theme.colorBlack};
  text-align: center;
  line-height: 1.5;
  overflow: hidden;

  @media only screen and (min-width: ${theme.breakpointMd}) {
    display: flex;
    align-items: center;
    padding: ${theme.verticalRhythm2x};
  }
`;

const Graphic = styled.div`
  position: relative;
  @media only screen and (min-width: ${theme.breakpointMd}) {
    order: 2;
    flex: 1 1 33%;
  }
`;
const Content = styled.div`
  text-align: center;

  @media only screen and (min-width: ${theme.breakpointMd}) {
    order: 1;
    flex: 1 1 66%;
    padding-right: ${theme.verticalRhythm2x};
    text-align: left;
  }
`;

const H2 = styled.h2`
  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial;
  font-size: ${theme.fontSizeH2};
  color: ${theme.colorBase};
  line-height: 1.3;

  @media only screen and (min-width: ${theme.breakpointMd}) {
    margin-top: 0;
    font-size: ${theme.fontSizeH1};
  }
`;

const P = styled.p`
  font-family: ${theme.fontFamilyPrimary};
  font-size: ${theme.fontSizeBase};
  color: ${theme.colorBase};
  line-height: 1.5;
`;

const TitleCard = ({ heading, body, link, graphic, borderColor }) => (
  <Container borderColor={borderColor}>
    <Graphic>{graphic()}</Graphic>
    <Content>
      <H2>{heading}</H2>
      <P>{body}</P>
      {link()}
    </Content>
  </Container>
);

TitleCard.propTypes = PROP_TYPES;
TitleCard.defaultProps = DEFAULT_PROPS;
TitleCard.displayName = 'TitleCard';

export default TitleCard;
